<template>
  <v-card class="elevation-0" @click="selectedDetails()">
    <v-card-text class="d-flex align-center py-1">
      <v-avatar>
        <v-img :src="chat.image"></v-img>
      </v-avatar>
      <div class="ml-2 text-center">
        <p class="subtitle-1 ma-0 pa-0">{{ chat.name }}</p>
        <p class="caption ma-0 pa-0">{{ chat.members }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["conversationId"],
  methods: {
    selectedDetails() {
      if (this.conversation.name) {
        this.$emit("details");
      }
    },
  },
  computed: {
    conversation() {
      return this.$store.state.trip.chats[this.$props.conversationId];
    },
    chat() {
      const item = {};
      const meId = this.$store.state.firUser.uid;
      if (this.conversation.name) {
        item.name = this.conversation.name;
        if (this.conversation.image_path) {
          item.image = this.$store.getters.getImageUrlById(this.$props.conversationId);
        }
        item.members = Object.keys(this.conversation.users)
          .map((id) => this.$store.getters.userShortName(id))
          .join(", ");
      } else {
        const partnerId = Object.keys(this.conversation.users).find((a) => a !== meId);
        item.name = this.$store.getters.getUserById(partnerId).name;
        item.image = this.$store.getters.getImageUrlById(partnerId);
      }

      if (!item.image) {
        item.image = require("@/assets/chat_bck.jpeg");
      }
      return item;
    },
  },
};
</script>
